import React from "react";
import { SupText } from "@repo/core-ui";

import { formatCurrency, formatPercent, formatTimestamp, formatNumber } from "../../../../utils/transactions";
import type { ValueProps } from "../../types";

export function Value({ value, type }: ValueProps) {
  switch (type) {
    case "usd":
      return (
        <SupText variant="subtitle1" className="whitespace-nowrap">
          {formatCurrency(typeof value === "string" ? parseFloat(value) : value)}
        </SupText>
      );
    case "percent":
      return (
        <SupText variant="subtitle1" className="whitespace-nowrap">
          {formatPercent(typeof value === "string" ? parseFloat(value) : value)}
        </SupText>
      );
    case "timestamp":
      return (
        <SupText variant="subtitle1" className="whitespace-nowrap">
          {formatTimestamp(typeof value === "string" ? parseInt(value, 10) : value)}
        </SupText>
      );
    case "number":
      return (
        <SupText variant="subtitle1" className="whitespace-nowrap">
          {formatNumber(typeof value === "string" ? parseFloat(value) : value)}
        </SupText>
      );
    default:
      return (
        <SupText variant="subtitle1" className="whitespace-nowrap">
          {value}
        </SupText>
      );
  }
}
